module.exports = "/assets/logo_sg_acrobat_dc-0e862b29e907667e904e8aa3391c4218.png";